//function to update the localFitlers based on the widgets
export default function generateLocalFilters(widgets){
    //need iterate the widgets and categorize the filters into multi-select or single-select
    let multiSelectFilterList = [];
    let singleSelectFilterList = [];

    widgets.forEach((widget) => {
        if (!widget.controlCard || !widget.filterSettings) return;
        widget.filterSettings.forEach((filterSetting) => {
        if (filterSetting.controlMode === "Multi-Select") {
            multiSelectFilterList.push({...filterSetting, groupId: widget.group});
        } else {
            singleSelectFilterList.push({...filterSetting, groupId: widget.group});
        }
        });
    });

    //now iterate multiSelectFilterList first with "or" logic and then singleSelectFilterList with "and" logic
    //to build the localFilterList
    const localFilterList = {};

    if(multiSelectFilterList.length > 0){
        multiSelectFilterList.forEach((filterSetting) => {
            const column = filterSetting.column;
            const value = filterSetting.value;
            const groupId = filterSetting.groupId;

            if(!value || value.length === 0) return;

            if(groupId){//if groupId exists, then it's a group filter
                localFilterList[groupId] = localFilterList[groupId] || {};
                if(!localFilterList[groupId][column]){
                    localFilterList[groupId][column] = {
                        filterType: "set",
                        values: [...value],
                    };
                }else{
                    localFilterList[groupId][column].values = [
                        ...new Set([...localFilterList[groupId][column].values, ...value])]
                }
            }else{
                localFilterList["all"] = localFilterList["all"] || {};
                if(!localFilterList["all"][column]){
                    localFilterList["all"][column] = {
                        filterType: "set",
                        values: [...value],
                    };
                }else{
                    localFilterList["all"][column].values = [
                        ...new Set([...localFilterList["all"][column].values, ...value]),
                    ];
                }
            };
        })
    }

    if(singleSelectFilterList.length > 0){
        singleSelectFilterList.forEach((filterSetting) => {
            if(filterSetting.value.length > 0){
                const column = filterSetting.column;
                const value = filterSetting.value;
                const groupId = filterSetting.groupId;

                if(!value || value.length === 0) return;

                if(groupId){//if groupId exists, then it's a group filter
                    localFilterList[groupId] = localFilterList[groupId] || {};
                    if(!localFilterList[groupId][column]){
                            localFilterList[groupId][column] = {
                                filterType: "set",
                                values: [...value],
                            };
                        }else{
                            localFilterList[groupId][column].values = value.filter(v => 
                                localFilterList[groupId][column].values.includes(v)
                            );
                        }
                }else{
                    localFilterList["all"] = localFilterList["all"] || {};
                    if(!localFilterList["all"][column]){
                        localFilterList["all"][column] = {
                            filterType: "set",
                            values: [...value],
                        };
                    }else{
                        localFilterList["all"][column].values = value.filter(v => 
                            localFilterList["all"][column].values.includes(v)
                        );
                    }
                }
            }
        })
    }

    //after building up the localFilterList, we have to go through the all and groupp to set up the filter again
    //in each grouped filter, if the filter is in the all filter, we have to get the common value
    const allFilter = localFilterList["all"];
    const updatedFilterlist = {};
    Object.keys(localFilterList).forEach((groupId) => {
        if(groupId === "all") {
            updatedFilterlist["all"] = allFilter;
        };
        updatedFilterlist[groupId] = {};
        Object.keys(localFilterList[groupId]).forEach((column) => {
            if(allFilter?.[column]){
                const commonValues = localFilterList[groupId][column].values.filter(v => allFilter[column].values.includes(v));
                updatedFilterlist[groupId][column] = {
                    ...localFilterList[groupId][column],
                    values: commonValues
                };
            }else{
                updatedFilterlist[groupId][column] = localFilterList[groupId][column];
            }
        })
    })

    return updatedFilterlist;
}
